<template>
    <div
        class="a-loader loader"
        at-a-loader
    >
        <span class="loader__square"/>
        <span class="loader__square"/>
        <span class="loader__square"/>
    </div>
</template>

<script>
export default {
    name: 'ALoader'
};
</script>

<style lang="scss">
    @import 'theme';
</style>
